import actionTypes from './actionTypes';

export function setFiltersAction(filters) {
    return {
        type: actionTypes.SAVE_FILTERS,
        data: filters,
    };
}
